import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Session from '../services/session'
import i from '../imports';
import c from '../components';
import Checkbox from 'material-ui/Checkbox';

const EMPTY_FILTER_VALUE = "empty_filter_value";

const floatingLabelStyle = {
    color: "#FF5563"
}

const underlineStyle = {
    borderColor: "#FF5563"
}

class EventDialog extends Component {
    constructor(props) {
        super(props)
        this.state = {
            eventsValues: []
        }
    }

    handleEventChecked = (event, value) => {

        console.log(this.state);
        var selectedValues = this.state.eventsValues;
        if(event.target.checked){
            selectedValues.push(value);
        }else{
            selectedValues.pop(value);
        }
        this.setState({
            eventsValues: selectedValues
        });
       
    }


    render() {

        return (
            <c.FormDialog
                form_title={this.props.form_title}
                form_description={this.props.form_title}
                onClose={this.props.onClose}
                openDialog={this.props.openDialog}
                calcValues={this.state}
                requestType ='eventRequest'
            >
                <i.Row>
                    <i.Col xs={12} sm={6} md={6}>
                        <i.Row>
                            <i.Col >
                                <i.Row>
                                    <i.Col style={{ fontWeight: 600, color: "#FF5563" }}>
                                        {this.props.eventsData[0].category}
                                    </i.Col>
                                </i.Row>
                                <i.Row style={{ paddingTop: 5 }}>
                                    <i.Col>
                                        {this.props.eventsData[0].events.map(event =>
                                            <Checkbox
                                                iconStyle={{ fill: "#FF5563" }}
                                                label={event.translate_name}
                                                uncheckedIcon={
                                                    <div viewBox="0 0 24 24" style={{
                                                        top: 3,
                                                        left: 4,
                                                        width: 15,
                                                        height: 15,
                                                        borderStyle: "solid",
                                                        borderWidth: 1,
                                                        borderColor: "#000000"
                                                    }}
                                                     />
                                                }
                                                onCheck={(e) => this.handleEventChecked(e, event.translate_name)}
                                            />
                                        )}
                                    </i.Col>
                                </i.Row>
                            </i.Col>
                        </i.Row>
                    </i.Col>
                    <i.Col xs={12} sm={6} md={6} align='left'>
                        <i.Row>
                            <i.Col >
                                <i.Row>
                                    <i.Col style={{ fontWeight: 600, color: "#FF5563" }}>
                                        {this.props.eventsData[1].category}
                                    </i.Col>
                                </i.Row>
                                <i.Row style={{ paddingTop: 5 }}>
                                    <i.Col>
                                        {this.props.eventsData[1].events.map(event =>
                                            <Checkbox iconStyle={{ fill: "#FF5563" }} label={event.translate_name}
                                                uncheckedIcon={
                                                    <div viewBox="0 0 24 24" style={{
                                                        top: 3,
                                                        left: 4,
                                                        width: 15,
                                                        height: 15,
                                                        borderStyle: "solid",
                                                        borderWidth: 1,
                                                        borderColor: "#000000"
                                                    }}/>
                                                }
                                                onCheck={(e) => this.handleEventChecked(e, event.translate_name)}
                                            />)}
                                    </i.Col>
                                </i.Row>
                            </i.Col>
                        </i.Row>
                    </i.Col>
                </i.Row>
                <i.Row>
                    <i.Col>
                        <br />
                    </i.Col>
                </i.Row>
            </c.FormDialog>
        )
    }

}

export { EventDialog };


